import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 740px;
  margin: auto;
  margin-top: 18vh;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  color: #181818;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #181818;
`;

export const Search = styled(Link)`
  display: flex;
  background: #ebf4ff;
  border-radius: 8px;
  padding: 16px 20px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  width: 100%;
  text-decoration: none;
`;

export const SearchLinkText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #181818;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
`;
